import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/UserWallet`;

const ApiUserWallet = {
  getUserWallet: (params) => {
    
    const url = `${baseServiceUrl}/getUserWallet`;
    

    return ServiceApi.get(url, params);
  },
  getWalletBalance: (params) => {
    
    const url = `${baseServiceUrl}/GetWalletBalance`;
    

    return ServiceApi.get(url, params);
  },
};

export default ApiUserWallet;
